import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Key.svg?component
var Key_exports = /* @__PURE__ */ __exportAll({
	default: () => Key_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M12.82 14.51 15.36 12l1.76.47a1.56 1.56 0 0 0 1.51-.47 1.58 1.58 0 0 0 .37-1.49l-.47-1.75.82-.76 1.76.47A1.56 1.56 0 0 0 22.62 8 1.58 1.58 0 0 0 23 6.52l-.47-1.75a2.35 2.35 0 0 0-3.33-3.33l-9.71 9.74a6.29 6.29 0 1 0 3.33 3.33" }, null, -1), createElementVNode("path", { d: "M4.26 17.84a1.9 1.9 0 1 0 3.8 0 1.9 1.9 0 1 0-3.8 0" }, null, -1)])]);
}
var Key_default = { render: render$1 };
//#endregion
export { Key_exports, Key_default as default, render$1 as render };

//# sourceMappingURL=Key.svg_component.js.map